import { Component, h } from 'preact';
import linkState from 'linkstate';

import { Inquiry } from '../../../../../types/inquiries';
import { HopplerModalizer } from '../../common/hoppler-modalizer.component';
import { FormattedNumberInput } from '../../common/formatted-number-input.component';
import { inquiryService } from '../../../../utils/inquiry.service';
import { ReqState } from '../../../../../types';


interface InqEditCommissionAmountModalProps {
  inquiry: Inquiry;
  onClose: () => void;
  onUpdateSuccess: () => void;
}

interface InqEditCommissionAmountModalState {
  hopplerAmount?: number;
  brokerAmount?: number;
  reqState?: ReqState;
}

export class InqEditCommissionAmountModal extends Component<InqEditCommissionAmountModalProps, InqEditCommissionAmountModalState> {
  constructor(props: InqEditCommissionAmountModalProps) {
    super(props);

    this.state = {
      hopplerAmount: props.inquiry.commissionHoppler,
      brokerAmount: props.inquiry.commissionCoBroker
    };
  }

  async onSubmit(event: Event) {
    event.preventDefault();

    const inquiry = this.props.inquiry;

    try {
      this.setState({ reqState: ReqState.IN_PROGRESS });
      const response = await inquiryService.updateCommissionAmount(inquiry.inquiryCode, this.state.hopplerAmount, this.state.brokerAmount);
      this.setState({ reqState: ReqState.SUCCESS });

      this.props.onClose();
      this.props.onUpdateSuccess();
    } catch (err) {
      this.setState({ reqState: ReqState.FAILED });
      console.error(err);
    }
  }

  isSubmitButtonEnabled() {
    return !!this.state.hopplerAmount;
  }

  getSubmitButton() {
    if (this.state.reqState === ReqState.IN_PROGRESS) {
      return (
        <button className="btn btn-secondary" disabled>
          <i className="fas fa-cog fa-spin" /> Submitting...
        </button>
      )
    } else {
      return (
        <button type="submit" className="btn btn-secondary">
          Submit
        </button>
      );
    }
  }

  render(props: InqEditCommissionAmountModalProps, state: InqEditCommissionAmountModalState) {
    return (
      <HopplerModalizer onClose={ () => null}>
        <div className="hi-edcolamtmod">
          <div className="hi-edcolamtmod__title-bar">
            <span className="hi-edcolamtmod__title-label">Commission Agreement</span>
            <button className="btn btn-link hi-edcolamtmod__title-close" onClick={ props.onClose }>
              <i className="fas fa-times" /> close
            </button>
          </div>

          <div className="hi-edcolamtmod__body">
            <form className="hi-edcolamtmod__content" onSubmit={ evt => this.onSubmit(evt) }>
              <div className="hi-input-group">
                <label className="hi-input-group__label">
                  Hoppler Commission Amount
                </label>
                <FormattedNumberInput className='form-control'
                  placeholder='PHP' prefix='PHP '
                  value={ state.hopplerAmount }
                  onChange={ linkState(this, 'hopplerAmount') } />
              </div>

              <div className="hi-input-group">
                <label className="hi-input-group__label">
                  Co-broker Commission Amount
                </label>
                <FormattedNumberInput className='form-control'
                  placeholder='PHP' prefix='PHP '
                  value={ state.brokerAmount }
                  onChange={ linkState(this, 'brokerAmount') } />
              </div>

              <div className="text-center">
                { this.getSubmitButton() }
              </div>
            </form>
          </div>
        </div>
      </HopplerModalizer>
    );
  }
}
